/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveFixedWingLineCrewRequest } from '../../models/remove-fixed-wing-line-crew-request';
import { RemoveFixedWingLineCrewResponse } from '../../models/remove-fixed-wing-line-crew-response';

export interface RemoveFixedWingLineCrew$Params {
  id: number;
      body: RemoveFixedWingLineCrewRequest
}

export function removeFixedWingLineCrew(http: HttpClient, rootUrl: string, params: RemoveFixedWingLineCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveFixedWingLineCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, removeFixedWingLineCrew.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoveFixedWingLineCrewResponse>;
    })
  );
}

removeFixedWingLineCrew.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines/{id}/crew/remove';
